var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAthlete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M26.208,12.375H23.292V9.458a1.458,1.458,0,1,0-2.917,0v2.917H17.458a1.458,1.458,0,1,0,0,2.917h2.917v2.917a1.458,1.458,0,1,0,2.917,0V15.292h2.917a1.458,1.458,0,0,0,0-2.917Z",
    transform: "translate(7.333 2.167)",
    fill: "#F89E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M11.75,17.5A8.75,8.75,0,1,0,3,8.75a8.75,8.75,0,0,0,8.75,8.75Zm0-14.583A5.833,5.833,0,1,1,5.917,8.75,5.833,5.833,0,0,1,11.75,2.917Z",
    transform: "translate(1.375 0)",
    fill: "#F89E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M13.125,14A13.14,13.14,0,0,0,0,27.125a1.458,1.458,0,1,0,2.917,0,10.208,10.208,0,0,1,20.417,0,1.458,1.458,0,0,0,2.917,0A13.14,13.14,0,0,0,13.125,14Z",
    transform: "translate(0 3.417)",
    fill: "#F89E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAthlete);
export default __webpack_public_path__ + "static/media/AddAthlete.53601976218655720d6fad6efe980b35.svg";
export { ForwardRef as ReactComponent };